var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "159.000000pt",
    height: "159.000000pt",
    viewBox: "0 0 159.000000 159.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,159.000000) scale(0.100000,-0.100000)",
    fill: "#D00202",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M845 1300 c-45 -18 -61 -68 -38 -117 28 -60 118 -61 148 -2 22 42 18 67 -14 100 -30 29 -58 35 -96 19z m63 -36 c24 -17 30 -62 10 -82 -30 -30 -88 -2 -88 43 0 20 32 55 50 55 3 0 16 -7 28 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 1209 c-34 -12 -47 -45 -33 -80 22 -53 100 -49 114 6 13 50 -33 92 -81 74z m45 -53 c4 -21 -14 -37 -35 -29 -14 5 -18 35 -6 47 12 12 38 1 41 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 1015 c-14 -21 -15 -31 -6 -50 7 -14 16 -25 22 -25 5 0 10 -22 10 -48 0 -43 -12 -67 -111 -237 -61 -105 -120 -209 -131 -231 -24 -48 -19 -83 14 -114 21 -19 34 -20 327 -20 225 1 310 4 322 13 26 20 41 58 36 86 -3 15 -62 123 -131 241 -136 233 -147 265 -106 317 25 32 25 55 2 76 -15 14 -40 17 -125 17 -103 0 -107 -1 -123 -25z m221 -30 c0 -18 -8 -20 -89 -23 -91 -3 -113 4 -102 33 5 13 21 15 98 13 85 -3 93 -5 93 -23z m-35 -96 c0 -34 22 -78 135 -273 74 -128 135 -238 135 -244 0 -7 -9 -21 -20 -32 -19 -19 -33 -20 -309 -20 -313 0 -321 1 -321 54 0 13 59 124 130 247 111 192 130 230 130 266 l0 43 60 0 60 0 0 -41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 579 c-30 -11 -122 -159 -117 -187 3 -14 19 -17 97 -20 72 -2 92 0 89 10 -3 9 -29 14 -76 16 -40 2 -72 5 -72 8 0 3 18 36 41 74 48 82 58 85 181 59 50 -10 104 -18 121 -16 27 2 34 -4 64 -53 18 -30 33 -58 33 -62 0 -5 -31 -8 -70 -8 -56 0 -70 -3 -70 -15 0 -13 14 -15 87 -13 109 4 112 10 48 118 l-46 79 -48 -6 c-28 -3 -76 1 -119 11 -79 18 -105 19 -143 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 390 c-3 -6 1 -13 10 -16 19 -8 30 0 20 15 -8 14 -22 14 -30 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedStep5);
export default __webpack_public_path__ + "static/media/feed-step-5.6fd7b12af5ce70d7b5abdc0229a7a4f0.svg";
export { ForwardRef as ReactComponent };